import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const Media = makeShortcode("Media");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "word-add-in"
    }}>{`Word Add-in`}</h1>
    <p>{`Document Generation Word Add-in provides the capability to author
templates to generate data-driven Word and PDF documents. It provides
the capability to add different tags and enable users to author
templates seamlessly. You can refer to the `}<a parentName="p" {...{
        "href": "#add-in-demo"
      }}>{`Add-in Demo`}</a>{` for the explanation
on how to use the add-in.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Adobe Document Generation Word Add-in is available
`}<a parentName="p" {...{
        "href": "https://appsource.microsoft.com/en-us/product/office/WA200002654"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "add-in-demo"
    }}>{`Add-In Demo`}</h2>
    <p>{`Document Generation add-in is developed in such a way that you don't
need to learn any code. The system does it all for you, as you'll see in
the video below:`}</p>
    <Media slots="video" mdxType="Media" />
    <p><a parentName="p" {...{
        "href": "https://images-tv.adobe.com/mpcv3/5158/38713027-f9e6-4020-ac97-7de5d873476f_1615914905.854x480at800_h264.mp4#t=1"
      }}>{`https://images-tv.adobe.com/mpcv3/5158/38713027-f9e6-4020-ac97-7de5d873476f_1615914905.854x480at800_h264.mp4#t=1`}</a></p>
    <h2 {...{
      "id": "how-to-install"
    }}>{`How to install`}</h2>
    <p>{`You can get the Document Generation `}<a parentName="p" {...{
        "href": "https://appsource.microsoft.com/en-us/product/office/WA200002654"
      }}>{`Word
Add-in`}</a>{`
from the Microsoft Office store. This add-in can be installed in both
the web-based and desktop launched MS Word application. Access to the
store is slightly different for each environment. Detailed instructions
for both are described below.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`If you are an Enterprise User, organizational Office 365 Admins or
user with admin rights can centrally
`}<a parentName="p" {...{
        "href": "#installing-at-the-tenant-level"
      }}>{`install the add-in at the tenant level`}</a>{`, and control access
at the user level if desired.`}</p>
    <p><strong parentName="p">{`Installing the add-in for the web-based client`}</strong></p>
    <ul>
      <li parentName="ul">{`Log in to your 365 Office account and open the word application.`}</li>
      <li parentName="ul">{`Navigate to the `}<strong parentName="li">{`Insert`}</strong>{` tab, and click the `}<strong parentName="li">{`Add-ins`}</strong>{` icon in
the insert section. Office Add-ins pop-up page will open up.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "15.312499999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/5530d/browser_insert_tab.webp 320w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/0c8fb/browser_insert_tab.webp 640w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/94b1e/browser_insert_tab.webp 1280w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/0b34d/browser_insert_tab.webp 1920w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/d5269/browser_insert_tab.webp 2560w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/527b8/browser_insert_tab.webp 2846w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/dd4a7/browser_insert_tab.png 320w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/0f09e/browser_insert_tab.png 640w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/bbbf7/browser_insert_tab.png 1280w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/ac7a9/browser_insert_tab.png 1920w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/c7a69/browser_insert_tab.png 2560w", "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/9d287/browser_insert_tab.png 2846w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/8927fe201ca2be06329a2c295031aad2/bbbf7/browser_insert_tab.png",
            "alt": "Insert tab in Microsoft Word Web",
            "title": "Insert tab in Microsoft Word Web",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "15.312499999999998%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/5530d/browser_addin_tab.webp 320w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/0c8fb/browser_addin_tab.webp 640w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/94b1e/browser_addin_tab.webp 1280w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/0b34d/browser_addin_tab.webp 1920w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/d5269/browser_addin_tab.webp 2560w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/b5543/browser_addin_tab.webp 2852w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/dd4a7/browser_addin_tab.png 320w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/0f09e/browser_addin_tab.png 640w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/bbbf7/browser_addin_tab.png 1280w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/ac7a9/browser_addin_tab.png 1920w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/c7a69/browser_addin_tab.png 2560w", "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/d3cd7/browser_addin_tab.png 2852w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/63b89729e90ee1a631dae8ede559c9ea/bbbf7/browser_addin_tab.png",
            "alt": "Select Add-Ins under the Insert tab in Microsoft Word Web",
            "title": "Select Add-Ins under the Insert tab in Microsoft Word Web",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">{`Check for the `}<strong parentName="li">{`Adobe Document Generation`}</strong>{` add-in in the `}<strong parentName="li">{`MY
ADDINS`}</strong>{` tab on Add-ins pop-up page.`}</li>
      <li parentName="ul">{`Navigate to the `}<strong parentName="li">{`STORE`}</strong>{` tab in the Office Add-ins pop-up, if the
add-in is not enabled/installed.`}</li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`If you face an issue, as illustrated below, while accessing your
Office Add-ins store then you can contact your organizational
Office 365 Admins to get
`}<a parentName="p" {...{
        "href": "#installing-at-the-tenant-level"
      }}>{`Add-in installed at the tenant level`}</a>{`.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/5530d/enterprise_error.webp 320w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/0c8fb/enterprise_error.webp 640w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/94b1e/enterprise_error.webp 1280w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/0b34d/enterprise_error.webp 1920w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/7b645/enterprise_error.webp 2406w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/dd4a7/enterprise_error.png 320w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/0f09e/enterprise_error.png 640w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/bbbf7/enterprise_error.png 1280w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/ac7a9/enterprise_error.png 1920w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/b67f0/enterprise_error.png 2406w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/bbbf7/enterprise_error.png",
            "alt": "Error message for enterprises when their organization has disabled access to Office Store in Microsoft Word Web",
            "title": "Error message for enterprises when their organization has disabled access to Office Store in Microsoft Word Web",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">{`Otherwise, In the top left search box, search for `}<strong parentName="li">{`Adobe Document Generation`}</strong>{` and click on add button.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "64.99999999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/5530d/document_generation_search_browser.webp 320w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/0c8fb/document_generation_search_browser.webp 640w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/94b1e/document_generation_search_browser.webp 1280w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/0b34d/document_generation_search_browser.webp 1920w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/a4087/document_generation_search_browser.webp 1986w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/dd4a7/document_generation_search_browser.png 320w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/0f09e/document_generation_search_browser.png 640w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/bbbf7/document_generation_search_browser.png 1280w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/ac7a9/document_generation_search_browser.png 1920w", "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/5b0a6/document_generation_search_browser.png 1986w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/9664e1fa1160f3641b805a90fe11b57d/bbbf7/document_generation_search_browser.png",
            "alt": "Office Add-Ins search result for Adobe Document Generation in Microsoft Word Web",
            "title": "Office Add-Ins search result for Adobe Document Generation in Microsoft Word Web",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">{`After enabling/installing the add-in, you will find a new Adobe
Document Generation add-in on the Home tab.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "24.375000000000004%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/5530d/browser_final2.webp 320w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/0c8fb/browser_final2.webp 640w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/94b1e/browser_final2.webp 1280w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/0b34d/browser_final2.webp 1920w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/d5269/browser_final2.webp 2560w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/dd410/browser_final2.webp 3396w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/dd4a7/browser_final2.png 320w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/0f09e/browser_final2.png 640w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/bbbf7/browser_final2.png 1280w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/ac7a9/browser_final2.png 1920w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/c7a69/browser_final2.png 2560w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/80448/browser_final2.png 3396w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/bbbf7/browser_final2.png",
            "alt": "Adding Document Generation in you home tab in Microsoft Word Web",
            "title": "Adding Document Generation in you home tab in Microsoft Word Web",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <p><strong parentName="p">{`Installing the add-in for the desktop client`}</strong></p>
    <ul>
      <li parentName="ul">{`Open your desktop Office application.`}</li>
      <li parentName="ul">{`Navigate to the `}<strong parentName="li">{`Insert`}</strong>{` tab, and click the `}<strong parentName="li">{`Get Add-ins`}</strong>{`
option.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "13.750000000000002%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/779ed3a5874907054f3f3916d6494837/5530d/desktop_insert_tab.webp 320w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/0c8fb/desktop_insert_tab.webp 640w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/94b1e/desktop_insert_tab.webp 1280w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/0b34d/desktop_insert_tab.webp 1920w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/ebf10/desktop_insert_tab.webp 2060w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/779ed3a5874907054f3f3916d6494837/dd4a7/desktop_insert_tab.png 320w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/0f09e/desktop_insert_tab.png 640w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/bbbf7/desktop_insert_tab.png 1280w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/ac7a9/desktop_insert_tab.png 1920w", "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/8a47e/desktop_insert_tab.png 2060w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/779ed3a5874907054f3f3916d6494837/bbbf7/desktop_insert_tab.png",
            "alt": "Insert tab in Microsoft Word",
            "title": "Insert tab in Microsoft Word",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "13.750000000000002%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/5530d/desktop_addin_tab.webp 320w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/0c8fb/desktop_addin_tab.webp 640w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/94b1e/desktop_addin_tab.webp 1280w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/0b34d/desktop_addin_tab.webp 1920w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/712d0/desktop_addin_tab.webp 2062w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/dd4a7/desktop_addin_tab.png 320w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/0f09e/desktop_addin_tab.png 640w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/bbbf7/desktop_addin_tab.png 1280w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/ac7a9/desktop_addin_tab.png 1920w", "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/b61eb/desktop_addin_tab.png 2062w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/1f204fafe7d3d5d3c19f06cf546c36b1/bbbf7/desktop_addin_tab.png",
            "alt": "Select Add-Ins under the Insert tab in Microsoft Word",
            "title": "Select Add-Ins under the Insert tab in Microsoft Word",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">{`Check for the `}<strong parentName="li">{`Adobe Document Generation`}</strong>{` add-in in the `}<strong parentName="li">{`MY
ADDINS`}</strong>{` tab on Add-ins pop-up page.`}</li>
      <li parentName="ul">{`Navigate to `}<strong parentName="li">{`STORE`}</strong>{` tab in the Office Add-ins popup, if add-in is
not already enabled/installed.`}</li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`If you face an issue, as illustrated below, while accessing your
Office Add-ins store then you can contact your organizational
Office 365 Admins to get
`}<a parentName="p" {...{
        "href": "#installing-at-the-tenant-level"
      }}>{`Add-in installed at the tenant level`}</a>{`.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.0625%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/5530d/enterprise_error.webp 320w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/0c8fb/enterprise_error.webp 640w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/94b1e/enterprise_error.webp 1280w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/0b34d/enterprise_error.webp 1920w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/7b645/enterprise_error.webp 2406w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/dd4a7/enterprise_error.png 320w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/0f09e/enterprise_error.png 640w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/bbbf7/enterprise_error.png 1280w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/ac7a9/enterprise_error.png 1920w", "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/b67f0/enterprise_error.png 2406w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/2cd233e03fb957edd1d564323a3f2e3b/bbbf7/enterprise_error.png",
            "alt": "Error message for enterprises when their organization has disabled access to Office Store in Microsoft Word",
            "title": "Error message for enterprises when their organization has disabled access to Office Store in Microsoft Word",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Otherwise, In the top left search box, search for `}<strong parentName="p">{`Adobe Document Generation`}</strong>{` and click on `}<strong parentName="p">{`add`}</strong>{` button to install.`}</p>
        <p parentName="li"><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1280px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.0625%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "display": "block",
                "transition": "opacity 0.5s 0.5s",
                "pointerEvents": "none"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/5530d/document_generation_search_desktop.webp 320w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/0c8fb/document_generation_search_desktop.webp 640w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/94b1e/document_generation_search_desktop.webp 1280w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/0b34d/document_generation_search_desktop.webp 1920w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/e5288/document_generation_search_desktop.webp 2342w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/dd4a7/document_generation_search_desktop.png 320w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/0f09e/document_generation_search_desktop.png 640w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/bbbf7/document_generation_search_desktop.png 1280w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/ac7a9/document_generation_search_desktop.png 1920w", "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/c19a1/document_generation_search_desktop.png 2342w"],
                "sizes": "(max-width: 1280px) 100vw, 1280px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/document-services/docs/static/026f47d50bc4d833c9eb894ecbac28b5/bbbf7/document_generation_search_desktop.png",
                "alt": "Office Add-Ins search result for Adobe Document Generation in Microsoft Word",
                "title": "Office Add-Ins search result for Adobe Document Generation in Microsoft Word",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "opacity": "0",
                  "transition": "opacity 0.5s",
                  "color": "inherit",
                  "boxShadow": "inset 0px 0px 0px 400px none",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <br />
      </li>
    </ul>
    <ul>
      <li parentName="ul">{`After enabling/installing the add-in, you will find a new Adobe
Document Generation add-in on the Home tab.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "24.375000000000004%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/5530d/browser_final2.webp 320w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/0c8fb/browser_final2.webp 640w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/94b1e/browser_final2.webp 1280w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/0b34d/browser_final2.webp 1920w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/d5269/browser_final2.webp 2560w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/dd410/browser_final2.webp 3396w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/dd4a7/browser_final2.png 320w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/0f09e/browser_final2.png 640w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/bbbf7/browser_final2.png 1280w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/ac7a9/browser_final2.png 1920w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/c7a69/browser_final2.png 2560w", "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/80448/browser_final2.png 3396w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/b4f034d2016b7cc3690916f3c546c1c2/bbbf7/browser_final2.png",
            "alt": "Adding Document Generation in you home tab in Microsoft Word",
            "title": "Adding Document Generation in you home tab in Microsoft Word",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Please refer to the official `}<a parentName="p" {...{
        "href": "https://support.microsoft.com/en-us/office/view-manage-and-install-add-ins-in-office-programs-16278816-1948-4028-91e5-76dca5380f8d"
      }}>{`Microsoft Add-In Installation
Guide`}</a>{`
for detailed steps on Add-In installation.`}</p>
    <h2 {...{
      "id": "installing-at-the-tenant-level"
    }}>{`Installing at the Tenant level`}</h2>
    <p>{`Installing at the tenant level allows the admin to expose the add-in by
default, saving the users the installation steps, and ensuring that all
users have access without issue.`}</p>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`The below process enables the add-in at the tenant level for the whole
user base. `}<a parentName="p" {...{
        "href": "https://docs.microsoft.com/en-gb/microsoft-365/admin/manage/manage-deployment-of-add-ins?redirectSourcePath=%252fen-us%252farticle%252fdeploy-office-add-ins-in-the-office-365-admin-center-737e8c86-be63-44d7-bf02-492fa7cd9c3f&view=o365-worldwide"
      }}>{`Check here if you would like more granular control over
the
deployment.`}</a><br />{`
`}<a parentName="p" {...{
        "href": "https://docs.microsoft.com/en-gb/microsoft-365/admin/manage/centralized-deployment-of-add-ins?view=o365-worldwide"
      }}>{`Determine if Centralized Deployment of add-ins works for your
organization.`}</a></p>
    <p><strong parentName="p">{`The enablement is quick and easy, taking only about 5 minutes`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">{`Log in as the Tenant admin, and navigate to the admin center from
the app launcher.`}</li>
      <li parentName="ul">{`In the admin center, go to the Settings `}{`>`}{` Add-ins page. If you
don't see the Add-in Page, go to the Settings `}{`>`}{` Integrated apps.`}</li>
      <li parentName="ul">{`On the top of the Integrated apps page, click the Add-ins link.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "38.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/5530d/admincenter_addin_tab.webp 320w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/0c8fb/admincenter_addin_tab.webp 640w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/94b1e/admincenter_addin_tab.webp 1280w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/0b34d/admincenter_addin_tab.webp 1920w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/d5269/admincenter_addin_tab.webp 2560w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/76f2e/admincenter_addin_tab.webp 3252w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/dd4a7/admincenter_addin_tab.png 320w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/0f09e/admincenter_addin_tab.png 640w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/bbbf7/admincenter_addin_tab.png 1280w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/ac7a9/admincenter_addin_tab.png 1920w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/c7a69/admincenter_addin_tab.png 2560w", "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/8e897/admincenter_addin_tab.png 3252w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/2138880de9ac2460306809e5ebce4bba/bbbf7/admincenter_addin_tab.png",
            "alt": "Microsoft 365 Admin Center Add-In tab",
            "title": "Microsoft 365 Admin Center Add-In tab",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">{`Select Deploy Add-in at the top of the page, and then select Next.`}</li>
      <li parentName="ul">{`Select the option to add an add-in from the Office Store. In the top
left search box, search for `}<strong parentName="li">{`Adobe Document Generation`}</strong>{` and click
on add button.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "41.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/5530d/tenant_search.webp 320w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/0c8fb/tenant_search.webp 640w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/94b1e/tenant_search.webp 1280w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/0b34d/tenant_search.webp 1920w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/d5269/tenant_search.webp 2560w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/f12a6/tenant_search.webp 2934w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/dd4a7/tenant_search.png 320w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/0f09e/tenant_search.png 640w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/bbbf7/tenant_search.png 1280w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/ac7a9/tenant_search.png 1920w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/c7a69/tenant_search.png 2560w", "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/a5cc3/tenant_search.png 2934w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/a2861f62f8dc36385011821cd03c54c1/bbbf7/tenant_search.png",
            "alt": "Microsoft 365 Admin Center tenant search results for Adobe Document Generation",
            "title": "Microsoft 365 Admin Center tenant search results for Adobe Document Generation",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">{`Assign Users`}
        <ul parentName="li">
          <li parentName="ul">{`Everyone - Applies the deployment method to all users in the
Tenant.`}</li>
          <li parentName="ul">{`Specific users/groups - Applies the deployment method to only
the selected users or groups.`}</li>
          <li parentName="ul">{`Just me - Applies the deployment method to just the user (admin)
doing the configuration`}</li>
        </ul>
      </li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.9375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/5530d/admincenter_assign_user.webp 320w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/0c8fb/admincenter_assign_user.webp 640w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/94b1e/admincenter_assign_user.webp 1280w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/0b34d/admincenter_assign_user.webp 1920w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/d5269/admincenter_assign_user.webp 2560w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/1e995/admincenter_assign_user.webp 2966w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/dd4a7/admincenter_assign_user.png 320w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/0f09e/admincenter_assign_user.png 640w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/bbbf7/admincenter_assign_user.png 1280w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/ac7a9/admincenter_assign_user.png 1920w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/c7a69/admincenter_assign_user.png 2560w", "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/96ce5/admincenter_assign_user.png 2966w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/docs/static/3a524b4e00d85021d680c126d1438c52/bbbf7/admincenter_assign_user.png",
            "alt": "Microsoft 365 Admin Center assigning Add-In to the user",
            "title": "Microsoft 365 Admin Center assigning Add-In to the user",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <br />
    <ul>
      <li parentName="ul">{`Click Deploy after assigning users.`}</li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
    <p>{`Users might need to relaunch Office to view the add-in icon on the app
ribbon.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      